export function quitGame() {}
